import { render, staticRenderFns } from "./CryptomatsCurrencies.vue?vue&type=template&id=25e18764&scoped=true&"
import script from "./CryptomatsCurrencies.vue?vue&type=script&lang=js&"
export * from "./CryptomatsCurrencies.vue?vue&type=script&lang=js&"
import style0 from "./CryptomatsCurrencies.vue?vue&type=style&index=0&id=25e18764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e18764",
  null
  
)

export default component.exports